import { render, staticRenderFns } from "./RightDefault.vue?vue&type=template&id=a9efcc7c&scoped=true"
import script from "./RightDefault.vue?vue&type=script&lang=js"
export * from "./RightDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9efcc7c",
  null
  
)

export default component.exports